import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor(private LoadeRef: MatDialogRef<LoaderComponent>,private snackbarService : SnackBarService) {
    LoadeRef.disableClose = true;
    this.snackbarService.InvokeCloseProgressSpinner.subscribe(value => {
      if(value === true){
       this.close(); 
     }
    }); 
   }
  public close() {
    this.LoadeRef.close(true);
  }
  ngOnInit(): void {
  }

}
